export default {
    GET_LIST_REQUEST: 'GET_LIST_REQUEST',
    GET_LIST_REQUEST_SUCCESS: 'GET_LIST_REQUEST_SUCCESS',
    GET_LIST_REQUEST_FAILE: 'GET_LIST_REQUEST_FAILE',
    GET_ORDERS_LIST: 'GET_ORDERS_LIST',
    SET_QUERY_REQUEST:'SET_QUERY_REQUEST'
};
